import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const BaggageIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M7.95 7.36422V4.44672C7.95 4.2 8.15147 4 8.4 4H15.6C15.8485 4 16.05 4.2 16.05 4.44672V7.36422H20.271C20.6736 7.36422 21 7.68821 21 8.08787V19.2764C21 19.676 20.6736 20 20.271 20H3.72896C3.32637 20 3 19.676 3 19.2764V8.08787C3 7.68821 3.32637 7.36422 3.72896 7.36422H7.95ZM8.85 7.36422H15.15V5.13919C15.15 4.92033 14.9713 4.74291 14.7508 4.74291H9.24919C9.02872 4.74291 8.85 4.92033 8.85 5.13919V7.36422Z'
                fill='currentColor'
            />
        </>
    ),
})

BaggageIcon.displayName = 'BaggageIcon'
